// extracted by mini-css-extract-plugin
module.exports = {"DefaultTheme__container___Z6XA3":"DefaultTheme__container___Z6XA3","DefaultTheme__tablist___1os49":"DefaultTheme__tablist___1os49"};